import React, { useEffect, useState } from 'react';
import { StyledTwoInARowLayout } from './StyledTwoInARowLayout';
import { checkIfOlderOsVersions } from 'utils';
import { EBundlesViewModel } from 'utils/enums';
import { IBundlesLayoutProps } from 'utils/types';
import { StyledBundleLayout } from './style';
import './style.scss';
import { StyledTwoInARowDynamicLayout } from './StyledTwoInARowDynamicLayout';

export const BundlesLayout: React.FC<IBundlesLayoutProps> = ({
  children,
  bundlesViewModel = EBundlesViewModel.LINEAR,
  gapY,
  gapX = '12px',
  maxWidthOverride = '400px',
  isPreview,
  desktopMaxWidth = '1250px',
  bundlesInternalViewModel,
  marginTop = '10px',
}) => {
  const [addedClasses, setAddedClasses] = useState<string>('');

  useEffect(() => {
    if (checkIfOlderOsVersions()) {
      setAddedClasses('bundles_layout--ios13');
    }
  }, []);

  switch (bundlesViewModel) {
    case EBundlesViewModel.LINEAR:
      return (
        <StyledBundleLayout
          gapY={gapY}
          bundlesInternalViewModel={bundlesInternalViewModel}
          gapX={gapX}
          className={`bundles_layout bundles_layout--mobile-linear ${addedClasses} ${bundlesInternalViewModel}`}
          bundleMaxWidth={maxWidthOverride || '400px'}
          desktopMaxWidth={desktopMaxWidth}
          marginTop={marginTop}
        >
          {children}
        </StyledBundleLayout>
      );
    case EBundlesViewModel.TWO_IN_ONE:
      return (
        <StyledTwoInARowLayout
          className={`bundles_layout bundles_layout__two-in-row ${addedClasses}`}
          isPreview={isPreview}
        >
          {children}
        </StyledTwoInARowLayout>
      );
    case EBundlesViewModel.THREE_IN_ONE:
      return (
        <StyledBundleLayout
          gapY={gapY}
          gapX={gapX}
          className={`bundles_layout bundles_layout--mobile-multiple-items ${addedClasses} ${bundlesInternalViewModel}`}
          bundleMaxWidth={maxWidthOverride || '400px'}
          desktopMaxWidth={desktopMaxWidth}
          marginTop={marginTop}
        >
          {children}
        </StyledBundleLayout>
      );
    case EBundlesViewModel.SIX_IN_ONE:
      return (
        <StyledBundleLayout
          gapY={gapY}
          gapX={gapX}
          className={`bundles_layout bundles_layout__six-in-row ${addedClasses} ${bundlesInternalViewModel}`}
          bundleMaxWidth={maxWidthOverride || '400px'}
          desktopMaxWidth={desktopMaxWidth}
          marginTop={marginTop}
        >
          {children}
        </StyledBundleLayout>
      );
    case EBundlesViewModel.TWO_IN_ONE_DYNAMIC:
      return (
        <StyledTwoInARowDynamicLayout
          className={`bundles_layout bundles_layout__two-in-row-dynamic ${addedClasses} ${bundlesInternalViewModel}`}
          isPreview={isPreview}
        >
          {children}
        </StyledTwoInARowDynamicLayout>
      );
    default:
      return null;
  }
};
